import numeral from "numeral";

const numFormat = (value) => {
  const currency = process.env.REACT_APP_USER_REGION === "INDIA" ? "₹" : "$";
  return `${currency} ` + numeral(value / 100).format("0,0.00");
};

export default numFormat;
